import { render, staticRenderFns } from "./ShiftUser.vue?vue&type=template&id=4c91342e&scoped=true"
import script from "./ShiftUser.vue?vue&type=script&lang=js"
export * from "./ShiftUser.vue?vue&type=script&lang=js"
import style0 from "./ShiftUser.vue?vue&type=style&index=0&id=4c91342e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91342e",
  null
  
)

export default component.exports